var links = document.links;
for (let i = 0, linksLength = links.length; i < linksLength; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
}


// Testimonial
var owl = $('.testimonial').owlCarousel({
  autoplay: false,
  loop: true,
  nav: true,
  dots: false,
  items: 1,
  autoHeight: true,
  smartSpeed: 800,
})


// Featured tab
var owl = $('.featuredtab').owlCarousel({
  autoplay: false,
  loop: false,
  nav: true,
  margin: 20,
  dots: false,
  smartSpeed: 800,
  responsive: {
    0: {
      items: 2,
      nav: false,
      dots: true
    },
    567: {
      items: 2,
      nav: false,
      dots: true
    },
    1000: { items: 3 },
    1200: { items: 4 }
  }
})


// Smooth auto scroll slider for each instance
document.addEventListener('DOMContentLoaded', function () {
  // Select all elements with a dynamic ID that matches 'smoothscroll-{section.id}'
  document.querySelectorAll('[id^="smoothscroll"]').forEach(function (slider) {
    new Splide(slider, {
      type: 'loop',
      drag: 'free',
      focus: 'center',
      direction: slider.getAttribute('data-direction'),
      arrows: false,
      autoWidth: true,
      pagination: false,
      perPage: 4,
      autoScroll: {
        speed: 0,
      },
    }).mount(window.splide.Extensions);
  });
});


// match Height js featured Tab
// function matchHeight(selector) {
//   const elements = document.querySelectorAll(selector);
//   let maxHeight = 0;

//   elements.forEach(el => {
//     el.style.height = 'auto'; // reset first
//   });

//   elements.forEach(el => {
//     if (el.offsetHeight > maxHeight) {
//       maxHeight = el.offsetHeight;
//     }
//   });

//   elements.forEach(el => {
//     el.style.height = maxHeight + 'px';
//   });
// }

// function waitForElementsToStabilize(selector, callback, maxAttempts = 10) {
//   let attempts = 0;
//   let lastMaxHeight = 0;

//   const interval = setInterval(() => {
//     const elements = document.querySelectorAll(selector);
//     let currentMaxHeight = 0;

//     elements.forEach(el => {
//       currentMaxHeight = Math.max(currentMaxHeight, el.offsetHeight);
//     });

//     if (currentMaxHeight === lastMaxHeight) {
//       clearInterval(interval);
//       callback();
//     }

//     lastMaxHeight = currentMaxHeight;
//     attempts++;

//     if (attempts >= maxAttempts) {
//       clearInterval(interval);
//       callback();
//     }
//   }, 300); // check every 300ms
// }

// // Initial and responsive trigger
// window.addEventListener('load', function () {
//   waitForElementsToStabilize('.Abz-featured-tab .card-wrapper', function () {
//     matchHeight('.Abz-featured-tab .card-wrapper');
//   });
// });

// window.addEventListener('resize', function () {
//   matchHeight('.Abz-featured-tab .card-wrapper');
// });

// Match Height JS
// window.onload = function() {
//   matchHeight('.AbzHeartgardBlock');
//   matchHeight('.abz-pack-size');
//   matchHeight('.card__content .card__heading a');
//   matchHeight('.card__content .caption-with-letter-spacing');
// };

// function matchHeight(selector) {
//   // Select all elements with the specified selector
//   var elements = document.querySelectorAll(selector);
//   var maxHeight = 0;

//   // First, find the tallest element
//   elements.forEach(function(element) {
//     if (element.offsetHeight > maxHeight) {
//       maxHeight = element.offsetHeight;
//     }
//   });

//   // Then, set all elements to the maxHeight
//   elements.forEach(function(element) {
//     element.style.height = maxHeight + 'px';
//   });
// }


// --------- remove extra - BEFOREabz-variant-extra
function removeDashBeforeOff() {
  document.querySelectorAll('.abz-variant-extra').forEach(el => {
    el.innerHTML = el.innerHTML.replace(/\s*-\s*(?=<span class="abz-price-off">)/, ' ');
  });
}
//------------------------------------

document.addEventListener('DOMContentLoaded', removeDashBeforeOff);
setTimeout(removeDashBeforeOff, 1000);

// --------- remove extra : colon
document.querySelectorAll('.product-option dt').forEach(function (dt) {
  // Get plain text and remove trailing colons/spaces
  let rawText = dt.textContent.replace(/:+\s*$/, '').trim();

  // Clear existing content and add cleaned text + styled colon
  dt.innerHTML = '';
  dt.appendChild(document.createTextNode(rawText));

  const colonSpan = document.createElement('span');
  colonSpan.className = 'colon';
  colonSpan.textContent = ':';

  dt.appendChild(colonSpan);
});

class FreeShippingProgressBar extends HTMLElement {
  constructor() {
    super();
    this.cartTotal = 0;
    this.shippingThreshold = 15000;
  }

  static get observedAttributes() {
    return ['cart-total'];
  }

  connectedCallback() {
    this.cartTotal = Number(this.getAttribute('cart-total')) || 0;
    const threshold = this.getAttribute('shipping-threshold');
    this.shippingThreshold = Number(threshold);

    // Hide the element if shipping threshold is not set
    if (!this.shippingThreshold) {
      this.style.display = 'none';
      return;
    }

    this.render();
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (oldValue !== newValue) {
      if (name === 'cart-total') {
        this.cartTotal = Number(newValue) || 0;
      }
      this.render();
    }
  }

  render() {
    const remainingAmount = this.shippingThreshold - this.cartTotal;
    const progress = Math.min((this.cartTotal / this.shippingThreshold) * 100, 100);

    let message = '';
    if (remainingAmount > 0) {
      const formattedRemainingAmount = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
      }).format(remainingAmount / 100);
      message = `Add <strong>${formattedRemainingAmount}</strong> to your cart to get free shipping!`;
    } else {
      message = "You've unlocked free shipping!";
    }

    this.innerHTML = `
      <div class="fs-progress-bar-container">
        <div class="fs-message">${message}</div>
        <div class="fs-bar">
          <div class="fs-bar-progress" style="width: ${progress}%;"></div>
        </div>
      </div>
    `;
  }
}

customElements.define('free-shipping-progress-bar', FreeShippingProgressBar);

// Custom element for applying discount codes
class AbzApplyDiscountCode extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input.cart__discount-input');
    this.button = this.querySelector('button.cart__discount-button');
    this.cartDrawer = document.querySelector('cart-drawer');

    if (this.input && this.button) {
      this.button.addEventListener('click', this.handleSubmit.bind(this));
    }
  }

  async handleSubmit(e) {
    e.preventDefault();

    const code = this.input.value.trim();
    if (!code) return;

    this.button.disabled = true;
    this.button.textContent = 'Applying...';

    try {
      const cartResponse = await fetch('/cart.js');
      const cart = await cartResponse.json();
      const existingDiscounts = cart.discount_codes.map(d => d.code);
      const uniqueDiscounts = [...new Set([...existingDiscounts, code])];
      const discountsString = uniqueDiscounts.join(',');

      const updateResponse = await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ discount: discountsString })
      });

      const result = await updateResponse.json();
      console.log(result, 'result');

      if (updateResponse.ok) {
        document.dispatchEvent(new CustomEvent('cart:updated', {
          detail: { cart: result }
        }));
        // Re-render cart drawer
        fetch(window.location.pathname)
          .then(response => response.text())
          .then(html => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            const newCartDrawer = doc.querySelector('cart-drawer');
            if (this.cartDrawer && newCartDrawer) {
              this.cartDrawer.innerHTML = newCartDrawer.innerHTML;
            }
            this.cartDrawer.open();
          });

        if (!result.discount_codes[result.discount_codes.length - 1].applicable) {
          alert('Discount Code Not Applicable');
        }
      } else {
        alert('Failed to apply discount code');
      }
    } catch (error) {
      console.error('Error applying discount code:', error);
    } finally {
      this.button.disabled = false;
      this.button.textContent = 'Apply';
      this.input.value = '';
    }
  }
}

customElements.define('abz-apply-discount-code', AbzApplyDiscountCode);

// Function to update cart total on the progress bar
function updateFreeShippingProgressBar(cart) {
  const progressBar = document.querySelector('free-shipping-progress-bar');
  if (progressBar) {
    progressBar.setAttribute('cart-total', cart.total_price);
  }
}

// Listen for cart changes
document.addEventListener('cart:updated', function (evt) {
  if (evt.detail && evt.detail.cart) {
    updateFreeShippingProgressBar(evt.detail.cart);
  }
});

// Fallback for cart updates
document.addEventListener('DOMContentLoaded', () => {
  const cartDrawer = document.querySelector('cart-drawer-items');
  if (cartDrawer) {
    const observer = new MutationObserver((mutations) => {
      setTimeout(() => {
        fetch('/cart.js')
          .then(response => response.json())
          .then(cart => {
            updateFreeShippingProgressBar(cart);
          });
      }, 500);
    });

    observer.observe(cartDrawer, {
      childList: true,
      subtree: true,
      attributes: true,
    });
  }
});



// ── ATC Button Price – Seal Subscriptions sync ──────────────────────────────

if(document.body.classList.contains('abz-new-template')) {

  // Update whenever Seal Subscriptions fires a price change
  document.addEventListener('sealsubs:price_update', function (e) {
    var price = e.detail && e.detail.price; // price in cents (integer)
    if (price == null) return;

    // Format using the store's currency (Intl) – mirrors Shopify's `| money`
    var formatted = (price / 100).toLocaleString('en-US', {
      style: 'currency',
      currency: window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : 'USD',
      minimumFractionDigits: 2,
    });

    document.querySelectorAll('.abz-atc-price').forEach(function (el) {
      el.textContent = " - " + formatted;
    });

    var stickyPrice = document.getElementById('abz-sticky-price');
    if (stickyPrice) stickyPrice.textContent = formatted;
  });
  // ─────────────────────────────────────────────────────────────────────────────

  // ── Subscription Benefits → Seal Subscriptions injection ──
  document.addEventListener('sealsubs:subscription_widget_created', function (e) {
    // The Liquid block renders a marker element carrying the template ID
    var marker = document.querySelector('[data-abz-sub-tpl]');
    if (!marker) return;

    var tpl = document.getElementById(marker.dataset.abzSubTpl);
    if (!tpl) return;

    // Find the target anchor inside the widget (use event detail when available)
    var widgetRoot = (e.detail && e.detail.element) ? e.detail.element : document;
    var anchor = widgetRoot.querySelector(
      '.sls-option-container[data-selling-plan-group] .sls-selling-plan-group-options'
    );
    if (!anchor) return;

    // Avoid duplicate injection
    if (anchor.nextElementSibling && anchor.nextElementSibling.classList.contains('abz-sub-benefits')) return;

    var clone = tpl.content.cloneNode(true);
    anchor.insertAdjacentElement('afterend', clone.querySelector('.abz-sub-benefits'));
  });


  document.addEventListener('sealsubs:subscription_widget_created', function (e) {
    var widgetRoot = (e.detail && e.detail.element) ? e.detail.element : '';
    console.log(widgetRoot, 'widgetRoot')
    if (!widgetRoot) return;

    var productInfo = widgetRoot.closest('.product__info-container');
    console.log(productInfo, 'productInfo')
    if (!productInfo) return;

    var label = productInfo.querySelector('.main-pdp-seal-widget-label');
    console.log(label, 'kk')

    // inject label just before widget container
    productInfo.insertBefore(label, widgetRoot);
  })

}
